import type { IconName } from '@layer-ui/components/media/Icon.vue'

export enum APIRoutes {
  HUBSPOT_CREATE_CONTACT = '/api/hub-spot/create-contact'
}

export enum AppTheme {
  LIGHT = 'Light',
  DARK = 'Dark'
}

export enum AppView {
  APP = 'App',
  VIDEO = 'Video'
}

export enum DarkSide {
  NEWS = '/news',
  CONTACT = '/contact',
  CLIENTS = '/clients'
}

export const DARK_ROUTES = [DarkSide.NEWS, DarkSide.CONTACT, DarkSide.CLIENTS]

export enum CardType {
  WORK = 'work',
  NEWS_EXPOSED = 'news-exposed',
  NEWS_LATEST = 'news-latest',
  NEWS = 'news',
  REEL = 'reel'
}

export type SocialLink = {
  label: string
  href: string
  icon?: IconName | null
}
